Drupal.behaviors.sidebarnavigation = {
  attach() {

    var winWidrh = window.innerWidth;
    if(winWidrh >= 1024){
      var dropdown = document.querySelectorAll(".sidebarnavigation li.li-active-trail");
      dropdown.forEach(function(element) {
        element.classList.add('menu-open');
      });
  
      var dropdownarrow = document.querySelectorAll(".sidebarnavigation li.li-active-trail > div:not(.submenu) .dropdown");
      dropdownarrow.forEach(function(e) {
        e.classList.add('open');
      });
    }
  
    var dropdowns = document.querySelectorAll('.sidebarnavigation .dropdown');  

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('click', function(){
        if(!this.closest('.li-wrapper').classList.contains('menu-open')){
          this.closest('.li-wrapper').classList.add("menu-open");
          this.classList.add("open");
        }
        else{
          this.closest('.li-wrapper').classList.remove("menu-open");
          this.classList.remove("open");
        } 

      });
    }); 
  },
};